import Vue from "vue";
import Avue from "@smallwei/avue";
import "@smallwei/avue/lib/index.css";

Vue.use(Avue, {
  size: "mini",
});
